import LocalStorageService from '@/services/LocalStorageService';
import {
  ICredentials, IToken, IAuthorizationResult,
  IResponse, IEmail, IPassword, IUserData,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';
// eslint-disable-next-line import/no-cycle
import UserService from '@/services/UserService';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import WebsocketService from '@/services/WebsocketService';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default class AuthService {
  public static login(credentials: ICredentials) {
    return ApiService.postAndReturnData('auth/login', credentials).then((response) => {
      if (response.success) {
        const mainStore = useMainStore();
        mainStore.resetAllStores();
        LocalStorageService.setAuthToken(response.results.authToken);
        return UserService.fetchAndStoreUser();
      }
      LocalStorageService.removeAuthToken();
      LocalStorageService.removeGmtId();
      return response;
    });
  }

  public static loginByToken(token: IToken): Promise<IResponse<IUserData>> {
    return ApiService.postAndReturnData('auth/loginByToken', token).then((response) => {
      if (response.success) {
        LocalStorageService.setAuthToken(response.results.authToken);
        const mainStore = useMainStore();
        mainStore.resetAllStores();
        return UserService.fetchAndStoreUser();
      }
      LocalStorageService.removeAuthToken();
      LocalStorageService.removeGmtId();
      return response;
    });
  }

  public static logout(): Promise<IResponse<null>> {
    const mainStore = useMainStore();
    MonitoringService.logEvents({
      logType: 'removeMobileToken',
      userId: mainStore.user?.accountId,
      key: 'ON_LOGOUT',
      id: mainStore.mobileToken,
    });
    const payload = { mobileToken: mainStore.mobileToken };
    return ApiService.postAndReturnData('auth/logout', payload).then((response) => {
      if (response.success) {
        // mainStore.resetUser();
        mainStore.resetAllStores();
        LocalStorageService.removeAuthToken();
        WebsocketService.closeSocket();
      }
      return response;
    });
  }

  public static deleteAccount(): Promise<IResponse<null>> {
    const mainStore = useMainStore();
    return ApiService.deleteAndReturnData('auth/account/step-1/my').then((response) => {
      if (response.success) {
        mainStore.resetUser();
        LocalStorageService.removeAuthToken();
        WebsocketService.closeSocket();
      }
      return response;
    });
  }

  public static resetPassword(payload: IEmail): Promise<IResponse<null>> {
    return ApiService.postAndReturnData('auth/passwordForgotten', payload);
  }

  public static confirmPasswordChange(token: IToken): Promise<IResponse<IAuthorizationResult>> {
    return ApiService.postAndReturnData('auth/passwordForgotten/confirmation', token).then((response) => {
      if (response.success) {
        LocalStorageService.setAuthToken(response.results.authToken);
      }
      return response;
    });
  }

  public static confirmEmail(token: IToken): Promise<IResponse<IAuthorizationResult>> {
    return ApiService.postAndReturnData('/auth/confirmation/email', token).then((response) => {
      if (response.success) {
        LocalStorageService.setAuthToken(response.results.authToken);
      }
      return response;
    });
  }

  // public static changeAccountPassword(payload: IAccountPassword): Promise<IResponse<null>> {
  //   return ApiService.postAndReturnData('auth/password/change', payload);
  // }

  public static changePassword(password: IPassword): Promise<IResponse<null>> {
    return ApiService.postAndReturnData('auth/password', password);
  }

  public static changeOldPassword(payload): Promise<IResponse<any>> {
    return ApiService.postAndReturnData('auth/password/check', payload);
  }

  public static sendLoginEmailLink(payload): Promise<IResponse<any>> {
    return ApiService.postAndReturnData('auth/auto-login/send', payload);
  }
  // public static changeUserEmail(newEmail: INewEmail): Promise<IResponse<null>> {
  //   return ApiService.postAndReturnData('auth/changeEmail', newEmail);
  // }

  // public static remindPassword(email: IEmail): Promise<IResponse<null>> {
  //   return ApiService.postAndReturnData('auth/passwordForgotten', email).then((response) => {
  //     if (response.success) {
  //       // store.commit('setUserProfile', email);
  //     }
  //     return response;
  //   });
  // }
}
